import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AutoDraftEntityEffects } from './auto-draft.effects';
import { AUTO_DRAFT_STATE_KEY } from './auto-draft.key';
import { autoDraftReducer } from './auto-draft.reducer';


@NgModule(
{
    imports:
    [
        StoreModule.forFeature(AUTO_DRAFT_STATE_KEY, autoDraftReducer),
        EffectsModule.forFeature([AutoDraftEntityEffects]),
    ],
})
export class AutoDraftStateModule { }
